import { Component } from 'react';

import { Grid, Box } from '@mui/material';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';

import JMiniAssignmentBox from 'components/JMiniAssignmentBox';
import JMiniGroupAssignments from 'components/JMiniGroupAssignments';
import { formatTag } from 'Utils/tag';
import styles from './styles';
import JSearchInput from 'components/JSearchInput';

class AssignmentList extends Component {
  constructor(props) {
    super(props);
  }

  onInlineFilter = (value) => {
    const { assignmentStore } = this.props.store;
    assignmentStore.setInlineFilter(value);
  };

  selectAssignment = (a) => {
    const { store, history } = this.props;
    const { assignmentStore, shipmentStore } = store;
    const { selectedAssignment = {}, date } = assignmentStore;
    const assignment = selectedAssignment ? selectedAssignment.assignment : null;
    const region = assignmentStore.regions.length > 0 ? assignmentStore.regions[0] : 'all';

    if (a && (!assignment || a.id !== assignment.id)) {
      history.push(`/routes/${date}/${region}/${a.id}`);
      assignmentStore.selectAssignment(a);
    } else {
      history.push(`/routes/${date}/${region}`);
      assignmentStore.selectAssignment(null);
    }

    shipmentStore.unselectStop();
  };

  render() {
    const { store } = this.props;
    const { assignmentStore } = store;
    const { selectedAssignmentId, completedAssignments, inProgressAssignments, pendingAssignments, unassignedAssignments } = assignmentStore;
    const axlMiniAssignmentBox = [
      { status: 'UNASSIGNED', color: '#bebfc0', assignments: unassignedAssignments },
      { status: 'PENDING', color: '#fa6725', assignments: pendingAssignments },
      { status: 'IN PROGRESS', color: '#fbc04f', assignments: inProgressAssignments },
      { status: 'COMPLETED', color: '#4abc4e', assignments: completedAssignments },
    ];

    return (
      <Grid container sx={styles.container}>
        <Grid sx={styles.gridItem}>
          <Box p={1} pb={0}>
            <JSearchInput
              placeholder="Search Assignment"
              value={assignmentStore.inlineFilter}
              onChange={this.onInlineFilter}
            />
          </Box>
        </Grid>
        <Grid size="grow" sx={{ ...styles.gridItem, ...styles.assignmentList }}>
          {axlMiniAssignmentBox.map((assignments, i) => (
            <JMiniGroupAssignments
              key={`assignment-group-${i}`}
              length={assignments.assignments.length}
              color={assignments.color}
              text={assignments.status}
              style={{ width: '100%' }}
            >
              {assignments.assignments.map((a) => {
                const assignmentTags = a.aggregated_tags
                  ? a.aggregated_tags.map((tag, i) => {
                      return {
                        text:
                          tag.toLowerCase() === 'commercial' ? (
                            <span style={styles.text}>
                              <i className="fa fa-clock-o" style={{ marginRight: '5px' }} />
                              {` Commercial`}
                            </span>
                          ) : (
                            <span style={styles.text}>{formatTag(tag)}</span>
                          ),
                        value: i,
                      };
                    })
                  : [];

                return (
                  <JMiniAssignmentBox
                    key={a.id}
                    tags={assignmentTags}
                    onClick={() => this.selectAssignment(a)}
                    assignment={a}
                    status={assignments.status}
                    style={{ opacity: !selectedAssignmentId || selectedAssignmentId === a.id ? 1.0 : 0.5 }}
                  />
                );
              })}
            </JMiniGroupAssignments>
          ))}
        </Grid>
      </Grid>
    );
  }
}

const AssignmentListCompose = compose(inject('store'), observer)(AssignmentList);

export default withRouter(AssignmentListCompose);
